import {createApp, defineAsyncComponent} from 'vue';
import {createPinia} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from './router';
import './assets/main.css';
import mvcVueIntegration from "@/MvcVueIntegration.ts";
import VueCookies from 'vue-cookies';

const components = mvcVueIntegration.getComponents();

function mountVueComponent(element: HTMLElement) {
	if (element.dataset.vueMounted === 'true') return;

	const componentName = element.dataset.vueComponent;
	if (!componentName) {
		console.error('No component name specified for element:', element);
		return;
	}

	const componentOrLoader = components[componentName];
	if (!componentOrLoader) {
		console.error(`Vue component "${componentName}" not found.`);
		return;
	}

	const props = JSON.parse(element.dataset.props || '{}');

	const component = typeof componentOrLoader === 'function'
		? defineAsyncComponent(componentOrLoader as () => Promise<any>)
		: componentOrLoader;

	const app = createApp(component, props);
	const pinia = createPinia();
	pinia.use(piniaPluginPersistedstate);
	app.use(pinia);
	app.use(router);
	app.use(VueCookies);
	app.mount(element);
	element.dataset.vueMounted = 'true';
}

function mountVueComponentsIn(root: ParentNode = document) {
	root.querySelectorAll<HTMLElement>('[data-vue-component]').forEach(mountVueComponent);
}

window.mountVueComponents = mountVueComponentsIn;

mountVueComponentsIn();
